import { render, staticRenderFns } from "./AssetPopup.vue?vue&type=template&id=006bfa9c&scoped=true"
import script from "./AssetPopup.vue?vue&type=script&lang=js"
export * from "./AssetPopup.vue?vue&type=script&lang=js"
import style0 from "./AssetPopup.vue?vue&type=style&index=0&id=006bfa9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bfa9c",
  null
  
)

export default component.exports